import { EntitiesStore } from './entities-store.abstract';
import { HttpClient, HttpParams } from '@angular/common/http';
import { tap, mergeMap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { EventGeneralInfoItem } from 'world-archery-lib';
import { WaHelperService } from '../../../library/wa-services/wa-helper-service';
import { CountryDependencyEntityStore } from './country-dependency-entity-store';
import { Injector } from '@angular/core';
import { CategoryCombo, CountryCombo } from '../filters-store/filters-store';
import { CompetitionStore } from './competition-store';



/**
 * Interface for athlete entry.
 *
 * @export
 * @interface IAthlete
 */
export interface IAthlete {
  Id: string;
  FName: string;
  GName: string;
  WNameOrd: boolean;
  NOC: string;
}

/**
 * Interface for category indicator of an entry.
 *
 * @export
 * @interface ICatInd
 */
export interface IEntryCatInd {
  Code: string;
  Qualification: number;
  Rank: number;
  WRank: number;
}

/**
 * Entry of a athlete for a competition.
 *
 * @export
 * @interface IEntry
 */
export interface IEntry {
  Athlete: IAthlete;
  CatInd: IEntryCatInd[];
  FundId: number;
}



/**
 * Competition status store
 *
 * @export
 * @class CompetitionStore
 * @extends {EntitiesStore<IÇompetitionStatus>}
 */
export class CompetitionEntriesStore extends EntitiesStore<IEntry> {
  constructor(http: HttpClient, injector: Injector) {
    super('ENTRIES', http, [{ entity: new CountryCombo('', '', http), params: { RBP: "ALL" } },

    ],
    );
  }

  /**
   * {@inheritdoc}
   *
   * @memberof CompetitionEntriesStore
   */
   getRequest(params, request_more){
    return super.getRequest(Object.assign(params, {'RBP':'ALL'}), request_more);
  }
}
